export * from "-!../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./index.vue?vue&type=template&id=7bc89bec&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/bonuses/index.vue?vue&type=template&id=7bc89bec&scoped=true
// module id = vYlM
// module chunks = 0